export default "__VITE_ASSET__BoRyMzxV__"